import datetimeFormats from "./dateTime";
const config = {
	datetimeFormats,
	fallbackLocale: "en"
};
export default () => config;
